var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Image } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import LogoWhiteHorizontal from '@/assets/img/logo-white-horizontal.svg';
import { NavLink } from '@/components';
import { isProd } from '@/config';
import { authRoutes } from '@/routes';
import { ROUTE } from '@/types';
import { useMemo } from 'react';
export const Footer = () => {
    const { pathname } = useLocation();
    const { t } = useTranslation();
    // Determines the application version based on the deployment tag.
    // - If a Git tag was used during deployment, `REACT_APP_VERSION` will contain the tag (e.g., "v1.2.3").
    // - If no deployment tag is available (e.g., local development or untagged builds), it falls back to `VERSION` from package.json.
    // - The package.json version may be visible in local development mode and Clinro builds.
    const appVersion = process.env.REACT_APP_VERSION || `${process.env.VERSION}`;
    const isAuthRoute = useMemo(() => authRoutes.includes(pathname), [pathname]);
    const links = useMemo(() => {
        const canNavigate = !isProd && isAuthRoute;
        return [
            {
                isExternal: true,
                label: t('app:components.navigation.terms_and_conditions.title'),
                to: ROUTE.TERMS_AND_CONDITIONS
            },
            {
                isExternal: true,
                label: t('app:components.navigation.privacy_policy.title'),
                to: ROUTE.PRIVACY_POLICY
            },
            {
                label: appVersion,
                sx: { cursor: canNavigate ? 'pointer' : 'default' },
                to: canNavigate ? ROUTE.TOOLS : undefined
            }
        ];
    }, [isProd, isAuthRoute]);
    return (_jsxs(Flex, Object.assign({ as: 'footer', bg: 'grey.80', color: 'white.100', direction: { base: 'column', md: 'row' }, fontSize: 'xs', gridGap: '8', p: '4', w: '100%' }, { children: [_jsx(Flex, Object.assign({ alignItems: 'center', direction: { base: 'column', md: 'row' }, flex: '1', gridGap: '4' }, { children: links.map((_a) => {
                    var { label } = _a, rest = __rest(_a, ["label"]);
                    return (_jsx(NavLink, Object.assign({}, rest, { children: label }), label));
                }) })), _jsx(Image, { alt: 'uMotif', m: 'auto', maxW: '80px', src: LogoWhiteHorizontal })] })));
};
